import { Controller } from "@hotwired/stimulus"

// Mobile nav: toggles the hamburger menu open and closed, swaps the icon,
// and closes the menu when a link inside it is tapped.
export default class extends Controller {
  static targets = [ "menu", "openIcon", "closeIcon" ]

  toggle() {
    const opening = this.menuTarget.classList.contains("hidden")
    this.menuTarget.classList.toggle("hidden", !opening)
    this.openIconTarget.classList.toggle("hidden", opening)
    this.closeIconTarget.classList.toggle("hidden", !opening)
    this.element.querySelector("button").setAttribute("aria-expanded", String(opening))
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.openIconTarget.classList.remove("hidden")
    this.closeIconTarget.classList.add("hidden")
    this.element.querySelector("button").setAttribute("aria-expanded", "false")
  }
}
